export default __webpack_public_path__ + "static/media/exercise-girl.346ee49c.jpg";